import { Mutation } from 'vuex';
import { IModuleState } from './types';

// gltf 文件的路径
export const setGltfPath: Mutation<IModuleState> = (state, payload) => {
  state.gltfPath.data = payload.data;
  state.gltfPath.loading = !!payload.loading;
};

// 上传之前的验证信息
export const setGltfPolicy: Mutation<IModuleState> = (state, payload) => {
  state.gltfPolicy.data = payload.data;
  state.gltfPolicy.loading = !!payload.loading;
};

// 当前物品是否存在 gltf 文件
export const setGltfExisted: Mutation<IModuleState> = (state, payload) => {
  state.gltfExisted.data = payload.data;
  state.gltfExisted.loading = !!payload.loading;
};

// 是否开启 gltf 预览
export const setGltfCanPreview: Mutation<IModuleState> = (state, payload) => {
  state.canPreview.data = payload.data;
  state.canPreview.loading = !!payload.loading;
};

// confirm 弹窗
export const setConfirm: Mutation<IModuleState> = (state, payload) => {
  state.confirm.visible = !!payload.visible;
  state.confirm.loading = !!payload.loading;
  state.confirm.title = payload.title;
  state.confirm.content = payload.content;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = payload;
};
